import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { SupportEmbedPage } from '@/pages/support/embed/SupportEmbedPage'

const supportEmbedSearchZod = z.object({
  page: z.coerce.string().optional(),
  object: z.coerce.string().optional(),
  objectUrl: z.coerce.string().optional(),
})

const SupportEmbedRoute = () => <SupportEmbedPage {...Route.useSearch()} />

export const Route = createFileRoute('/soutien/panneau')({
  component: withErrorBoundary(SupportEmbedRoute, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: supportEmbedSearchZod,
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
